angular.module('BlogControllers', [])

  //config for /supports
  .config(['$routeProvider', function($routeProvider) {
    $routeProvider

      // blog
      .when('/blog/:title', {
        templateUrl: '/ng1/www/modules/blog/html/detail.html',
        controller: 'BlogDetailCtrl'
      })
      .when('/blog/', {
        templateUrl: '/ng1/www/modules/blog/html/list.html',
        controller: 'BlogListCtrl'
      });

  }
  ]);
